import { QuyDoiDonViTinhChiTiet } from '@/types/schemas';
import { ExcelColumnMapping } from './types';

export const QUY_DOI_DON_VI_TINH_COLUMNS: ExcelColumnMapping<QuyDoiDonViTinhChiTiet>[] = [
  {
    header: 'Mã vật tư',
    width: 25,
    resolver: row => row.ma_vt_data?.ma_vt || ''
  },
  {
    header: 'Tên vật tư',
    width: 35,
    resolver: row => row.ma_vt_data?.ten_vt || ''
  },
  {
    header: 'Đvt',
    width: 18,
    resolver: row => row.dvt_data?.dvt || row.dvt || ''
  },
  {
    header: 'Hệ số',
    width: 15,
    numFmt: '#,##0.0000',
    resolver: row => Number(row.he_so ?? '')
  },
  {
    header: 'Đvt gốc',
    width: 18,
    resolver: row => row.dvt_goc || ''
  },
  {
    header: 'Khối lượng',
    width: 18,
    resolver: row => (row.khoi_luong != null ? Number(row.khoi_luong) : '')
  }
];
